import React, { useEffect, useState, createElement } from 'react';
import { ArrowRightIcon, MousePointerClickIcon, SearchIcon, PuzzleIcon, PlugIcon, SmartphoneIcon, GaugeIcon, ShieldCheckIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { AlkmaarSkyline } from '../components/AlkmaarSkyline';
export function WordPressWebsiteAlkmaarPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'WordPress website Alkmaar | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'WordPress website laten maken in Alkmaar? Flexibele, snelle en SEO-vriendelijke WordPress websites voor ondernemers in Alkmaar. Door Noord Digital.';
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: 'Waarom is WordPress een goede keuze voor mijn website?',
    a: 'WordPress is het meest gebruikte CMS ter wereld en wordt ingezet door meer dan 40% van alle websites. Het is gebruiksvriendelijk, flexibel uitbreidbaar en uitstekend geschikt voor SEO. Daardoor is het de ideale basis voor een professionele bedrijfswebsite in Alkmaar.'
  }, {
    q: 'Is WordPress veilig genoeg voor mijn bedrijfswebsite?',
    a: 'Ja, mits het goed wordt onderhouden. Wij zorgen voor veilige hosting, regelmatige updates, SSL-certificaten en beveiligingsplugins. Zo blijft jouw WordPress website in Alkmaar altijd beschermd tegen bedreigingen.'
  }, {
    q: 'Kan ik zelf de content van mijn WordPress website aanpassen?',
    a: "Absoluut. WordPress is ontworpen om eenvoudig te beheren. Na oplevering geven wij je een uitgebreide uitleg zodat je zelf teksten, afbeeldingen en pagina's kunt aanpassen zonder technische kennis."
  }];
  return <main className="pt-16 lg:pt-[72px]" data-id="element-3025" data-mp="1kej8r1j5fbgy">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-3026" data-mp="1kd84z1ppe3pu">
        <div className="absolute inset-0 pointer-events-none" data-id="element-3027" data-mp="1yczn9en9669n">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-3028" data-mp="1tfr4bbua5y7c" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-3029" data-mp="2832epaeq7c5v" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-3030" data-mp="235j1mdtrl5fi" />
        </div>

        {/* Alkmaar Skyline */}
        <div className="absolute bottom-0 left-0 right-0 opacity-[0.08] pointer-events-none" data-id="element-3031" data-mp="2vpednsi5cl2o">
          <AlkmaarSkyline className="w-full h-auto" color="#ffffff" data-id="element-3032" data-mp="30ohltltfb7ev" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3033" data-mp="2mqau6nf2i3nn">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up" data-id="element-3034" data-mp="2rokqx2gfxcbd">
            WordPress website laten maken in Alkmaar
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto mb-10 animate-fade-in-up-delay-1" data-id="element-3035" data-mp="2hrzkqdsopv5y">
            Flexibele en SEO-vriendelijke websites voor ondernemers in Alkmaar.
            Gebouwd op WordPress, het meest betrouwbare CMS ter wereld.
          </p>
          <div className="animate-fade-in-up-delay-2" data-id="element-3036" data-mp="1u2f1ruwj6xwo">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-bold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-lg" data-id="element-3037" data-mp="1u2ncph93ft58">
              Plan een gesprek
              <ArrowRightIcon className="w-5 h-5" data-id="element-3038" data-mp="2smciuwkm0vtm" />
            </a>
          </div>
        </div>
      </section>

      {/* Waarom WordPress */}
      <section className="py-24 bg-surface-muted" data-id="element-3039" data-mp="2nm6oh8mygv7u">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3040" data-mp="2nleycdc4npoy">
          <div className="text-center mb-16" data-id="element-3041" data-mp="2ippy07saa4rl">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3042" data-mp="2dpbn8hzasgpv">
              Waarom WordPress?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-3043" data-mp="29oi19u5f1bzm">
              WordPress is de beste keuze voor ondernemers die een
              professionele, beheersbare website willen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3044" data-mp="7vlj7nd39960">
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3045" data-mp="2ybvqd99f7kt">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3046" data-mp="ag09senmnjay">
                <MousePointerClickIcon className="w-6 h-6 text-accent" data-id="element-3047" data-mp="fe1okne0swgm" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3048" data-mp="k6uxlngiuqyi">
                Gebruiksvriendelijk
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3049" data-mp="p7ijjupw8hlv">
                Pas zelf eenvoudig teksten, afbeeldingen en pagina's aan zonder
                technische kennis.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3050" data-mp="3snzdzr16gq1e">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3051" data-mp="5hgn2c17m3hj">
                <SearchIcon className="w-6 h-6 text-accent" data-id="element-3052" data-mp="1cva7xwopkl3i" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3053" data-mp="1cxcuu7ukdy40">
                SEO-vriendelijk
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3054" data-mp="3dwzq8l56k8pb">
                WordPress biedt uitstekende SEO-mogelijkheden waardoor je beter
                gevonden wordt in Google.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3055" data-mp="3my69v334lzms">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3056" data-mp="3hzweosheiz16">
                <PuzzleIcon className="w-6 h-6 text-accent" data-id="element-3057" data-mp="2ua2128p9d6fv" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3058" data-mp="2q8ghy5m4rvx8">
                Flexibel uitbreidbaar
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3059" data-mp="340mwjn9mxuuk">
                Groeit jouw bedrijf? Dan groeit je WordPress website moeiteloos
                mee met extra functionaliteiten.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3060" data-mp="2bgobyk887u86">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3061" data-mp="26htupmpwqdq6">
                <PlugIcon className="w-6 h-6 text-accent" data-id="element-3062" data-mp="qsc83upq8pph" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3063" data-mp="qugm55hcb53h">
                Veel integraties
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3064" data-mp="i01wc8z6oc64">
                Koppel eenvoudig tools zoals Google Analytics, mailchimp,
                boekingssystemen en meer.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WordPress voor bedrijven */}
      <section className="py-24 bg-white" data-id="element-3065" data-mp="vrfdjg9mcxxz">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3066" data-mp="vqdr6fn5kp0y">
          <div className="text-center mb-16" data-id="element-3067" data-mp="10q9t89cai6dv">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3068" data-mp="10oypuamrb0na">
              WordPress webdesign voor bedrijven in Alkmaar
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-3069" data-mp="3lgh9dxeiiwlc">
              Elke WordPress website die wij bouwen voldoet aan de hoogste
              standaarden.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3070" data-mp="bzbmtzvritoa">
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3071" data-mp="c27kdn3p7gc7">
              <div className="flex items-start gap-4" data-id="element-3072" data-mp="21ot479t0xk9">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3073" data-mp="2388zwrjt6li">
                  <SmartphoneIcon className="w-6 h-6 text-navy-700" data-id="element-3074" data-mp="zonrcmg5adk9" />
                </div>
                <div data-id="element-3075" data-mp="uquni02bdvn5">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3076" data-mp="usoxijc1s3cg">
                    Responsive design
                  </h3>
                  <p className="text-slate-600" data-id="element-3077" data-mp="l12sj4qaz0i5">
                    Jouw WordPress website ziet er perfect uit op elk apparaat,
                    van mobiel tot desktop.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3078" data-mp="1dnvrpio1nrq1">
              <div className="flex items-start gap-4" data-id="element-3079" data-mp="1m07arjvglwgu">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3080" data-mp="1q0hj336q4yyv">
                  <SearchIcon className="w-6 h-6 text-navy-700" data-id="element-3081" data-mp="1uwy4hpmjgz89" />
                </div>
                <div data-id="element-3082" data-mp="1zyf3fflgqbm7">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3083" data-mp="1zyxa765r488d">
                    SEO-basis
                  </h3>
                  <p className="text-slate-600" data-id="element-3084" data-mp="28yaj9xpyqusk">
                    Technische SEO-optimalisatie is standaard inbegrepen, zodat
                    je direct vindbaar bent in Alkmaar en omgeving.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3085" data-mp="2inc17tg2jm96">
              <div className="flex items-start gap-4" data-id="element-3086" data-mp="2nldg026gozeu">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3087" data-mp="2snci78qgtqa7">
                  <GaugeIcon className="w-6 h-6 text-navy-700" data-id="element-3088" data-mp="3v52s56pj1e5n" />
                </div>
                <div data-id="element-3089" data-mp="30ifez0r0e6m">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3090" data-mp="2zyurajprbow">
                    Snelle laadtijd
                  </h3>
                  <p className="text-slate-600" data-id="element-3091" data-mp="cpigqp2q3lnz">
                    Wij optimaliseren elke WordPress website voor snelheid, wat
                    zorgt voor een betere gebruikerservaring en hogere
                    Google-ranking.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3092" data-mp="qorwxoqxifry">
              <div className="flex items-start gap-4" data-id="element-3093" data-mp="vomozvmfxbel">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3094" data-mp="vm0h1uvn0tvu">
                  <ShieldCheckIcon className="w-6 h-6 text-navy-700" data-id="element-3095" data-mp="2xfreom4tc1wa" />
                </div>
                <div data-id="element-3096" data-mp="2pw8beu855bw9">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3097" data-mp="2pwqi6ksfj8if">
                    Beveiliging
                  </h3>
                  <p className="text-slate-600" data-id="element-3098" data-mp="2l4qau7a15dbt">
                    SSL-certificaat, beveiligingsplugins en regelmatige updates
                    houden jouw website veilig en beschermd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proces */}
      <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-3099" data-mp="38t00jkad6l88">
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-3100" data-mp="33wj3g0l6swj0" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3101" data-mp="1nhhrahtlaecg">
          <div className="text-center mb-16" data-id="element-3102" data-mp="1nfevti9o3t0c">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-3103" data-mp="1jf3as4de7qoc">
              Ons proces
            </h2>
            <p className="text-lg text-navy-300 max-w-2xl mx-auto" data-id="element-3104" data-mp="1kxuy96w7kc0f">
              In 5 heldere stappen naar jouw WordPress website in Alkmaar.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6" data-id="element-3105" data-mp="1azx9miafsd7a">
            {['Kennismaking', 'Strategie', 'Ontwerp', 'Ontwikkeling', 'Livegang'].map((step, i) => <div key={step} className="bg-white/[0.06] border border-white/10 p-6 rounded-2xl text-center relative" data-id="element-3106" data-mp="124zf56rn4sdu" data-mpi={i}>
                <span className="absolute top-2 right-4 text-4xl font-bold text-white/[0.05]" data-id="element-3107" data-mp="sa7hy41z07jl">
                  {i + 1}
                </span>
                <div className="w-10 h-10 rounded-full bg-accent/20 text-accent flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-3108" data-mp="j7y5h8n5643k">
                  {i + 1}
                </div>
                <h3 className="text-white font-bold" data-id="element-3109" data-mp="nbe3o9ev0cid">{step}</h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* Gerelateerde pagina's */}
      <section className="py-16 bg-white border-b border-navy-100" data-id="element-3110" data-mp="3vteqsdxfqdr0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3111" data-mp="dn0eejetebuq">
          <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-3112" data-mp="8mcpq4e2673o">
            Ontdek meer:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-3113" data-mp="njlnbftyg73u">
            <a href="#/website-laten-maken" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3114" data-mp="nhsdxsryj8s5">
              Website laten maken
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-3115" data-mp="sabpkk733tub">•</span>
            <a href="#/wordpress-websites" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3116" data-mp="sd7n47f0sgi8">
              WordPress websites
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-3117" data-mp="1ldw906tc6cie">•</span>
            <a href="#/hosting-onderhoud" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3118" data-mp="1lbjuk3mseka3">
              Hosting & onderhoud
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-surface-muted" data-id="element-3119" data-mp="1z49iwepsg1ad">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3120" data-mp="12fa7iqtwqjdy">
          <div className="text-center mb-16" data-id="element-3121" data-mp="12h4v6cwkcplq">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3122" data-mp="16flvachkgztn">
              Veelgestelde vragen over WordPress in Alkmaar
            </h2>
          </div>

          <div className="space-y-4" data-id="element-3123" data-mp="1ge9yi54w7ada">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-soft overflow-hidden" data-id="element-3124" data-mp="1gc6z4uhuo4vw" data-mpi={index}>
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-3125" data-mp="2rsx82ldnrat7">
                  <span className="font-bold text-navy-900" data-id="element-3126" data-mp="b8bexerj5sra">{faq.q}</span>
                  {openFaq === index ? <ChevronUpIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-3127" data-mp="6f8rzph9dhk2" /> : <ChevronDownIcon className="w-5 h-5 text-navy-400 flex-shrink-0" data-id="element-3128" data-mp="1gxixgysfb2w" />}
                </button>
                {openFaq === index && <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-3129" data-mp="3olwvjawntwnm">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-3130" data-mp="3eq3g9jrk3p25" />
    </main>;
}